import { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import TopInfos from "./components/TopInfos";
import Stats from "./components/Stats";
import Performance from "./components/Performance";
import BestProduct from "./components/BestProduct";
import Goals from "./components/Goals";
import CountriesBooks from "./components/CountriesBooks";
import products from "@data/products.json"; //recuperation automatique
import { useTranslation } from "react-i18next";

function Home(props) {
  const [deleteProductModal, setDeleteProductModal] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <TopInfos props={props} />
      <Stats products={products.products} mode={props.profile.mode} />
      <Row>
        <Col lg="6" xl="8" className="my-2">
          <Performance mode={props.profile.mode} t={t} />
        </Col>
        <Col lg="6" xl="4" className="my-2">
          <BestProduct mode={props.profile.mode} products={products.products} />
        </Col>

        <Col xl="6" className="my-2">
          <CountriesBooks mode={props.profile.mode} />
        </Col>
        <Col xl="6" className="my-2">
          <Goals mode={props.profile.mode} t={t} />
        </Col>
      </Row>
      <Modal
        show={deleteProductModal}
        onHide={() => setDeleteProductModal(false)}
      >
        <Modal.Body className="text-dark">
          <p className="text-dark fs-5 fw-light py-4">{t("delete_product")}</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="p-3 btn-outline-blue"
            onClick={() => setDeleteProductModal(false)}
          >
            {t("cancel")}
          </button>
          <button
            className="p-3 btn-blue"
            onClick={() => setDeleteProductModal(false)}
          >
            {t("confirm")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default Home;
